<template>
  <div>
    <span v-show="false">{{ viewConfig }}</span>

    <DxPivotGrid :allow-sorting-by-summary="true" :allow-sorting="true" :allow-filtering="true" :show-borders="true"
      :data-source="dataSource" :showRowGrandTotals="false" :showColumnGrandTotals="false" :showColumnTotals="false"
      :height="600">
      <DxFieldChooser :enabled="true" :allow-search="true" />
      <DxExport :enabled="true" />
      <DxHeaderFilter :allow-search="true" :show-relevant-values="true" :width="300" :height="400" />
      <DxFieldPanel :visible="true" />
    </DxPivotGrid>
  </div>
</template>

<script>
import DxPivotGrid, {
  DxExport,
  DxFieldChooser,
  DxHeaderFilter,
  DxFieldPanel,
} from "devextreme-vue/pivot-grid";
import CustomStore from "devextreme/data/custom_store";
import PivotGridDataSource from "devextreme/ui/pivot_grid/data_source";

import Api from "@/api";

export default {
  components: {
    DxPivotGrid,
    DxExport,
    DxFieldChooser,
    DxHeaderFilter,
    DxFieldPanel,
  },
  props: ["viewId", "viewConfig"],
  data: () => ({}),
  computed: {
    dataSource() {
      let viewId = this.viewId;

      let fields = this.viewConfig.fields.map((e) => {
        let field = {
          dataField: e.fieldName,
          caption: e.caption,
          dataType: this.getDataType(e.dataType),
          area: this.titleCase(e.area),
          expanded: e.expanded,
          width: e.width,
        };

        if (e.area === "Data") {
          field.summaryType = e.summaryType;
          field.format = { precision: 2 };
        }

        return field;
      });

      return new PivotGridDataSource({
        store: new CustomStore({
          key: "uid",
          load(loadOptions) {
            return Api.getPivotGridData(viewId).then((data) => ({
              data: data.data,
            }));
          },
        }),
        fields: fields,
      });
    }
  },
  methods: {
    titleCase(string) {
      return string.charAt(0).toLowerCase() + string.slice(1);
    },

    getDataType(value) {
      let columnTypes = ["string", "date", "number", "number"]

      return columnTypes[value];
    },
  }
}
</script>